







import Vue from 'vue'
import { SpamBannerElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SpamBanner',

  mounted () {
    this.hideParentElements()
    setTimeout(this.showPopup, 200)
  },

  methods: {
    hideParentElements () {
      const element = this.$refs.spamBanner as HTMLDivElement
      if (element.parentElement && element.parentElement.parentElement) {
        // The Item.vue of this element should be hidden
        element.parentElement.parentElement.style.display = 'none'
      }
    },
    showPopup () {
      if (Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'uri')) {
        return this.getView(this.templateItemData.view ?? 'card', this.$props.templateItemData.uri)
      }
      if (Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'content')) {
        return this.getView(this.templateItemData.view ?? 'card', this.$props.templateItemData.content)
      }
    }
  },

  props: {
    templateItemData: {
      type: Object as () => SpamBannerElInterface,
      required: true
    }
  }
})
